Wee.fn.make('projectDetail', {
	init: function() {
		this.$private.total();

		Wee.easySlide.init({
			elementRef: 'portQuote',
			trackerRef: 'dot'
		});

		if ($('ref:sliderImage').length) {
			var two = new Wee.fn.easySlide();

			two.init({
				elementRef: 'sliderImage',
				trackerRef: 'imgThumb',
				arrows: 'arrow',
				thumbs: true
			});
		}
	}
}, {

	/**
	 * Get total number of images in slider and sets the value
	 *
	 * @private
	 */
	total: function() {
		$('ref:totalImgNum').text($('ref:imgThumb').length);
	}
});